const shouldDisableAdd = ({
  categoryMax,
  categoryAutoBalance,
  itemMax,
  currentItemQuantity,
  categoryTotal,
} = {}) => {
  const isMaxItem = itemMax !== -1 && currentItemQuantity >= itemMax;

  if (categoryAutoBalance) return isMaxItem;

  const isMaxCategory = categoryMax && categoryMax !== -1 && categoryTotal >= categoryMax;

  return isMaxCategory || isMaxItem;
};

const shouldDisableRemove = ({ currentItemQuantity, itemMin, isRootProduct, name } = {}) => {
  const formattedMin = isRootProduct ? 1 : itemMin;

  const isMinItem = currentItemQuantity <= formattedMin;

  return isMinItem;
};

const evaluateDisabledActions = ({
  categoryAutoBalance,
  currentItemQuantity,
  itemMin,
  itemMax,
  isRootProduct,
  categoryMax,
  categoryTotal,
} = {}) => {
  return {
    removeDisabled: shouldDisableRemove({
      currentItemQuantity,
      isRootProduct,
      itemMin,
    }),
    addDisabled: shouldDisableAdd({
      categoryMax,
      categoryAutoBalance,
      itemMax,
      currentItemQuantity,
      categoryTotal,
    }),
  };
};

export { evaluateDisabledActions };
